// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"CV","sticky_header_title":"EV","stycky_header_title_mob":"FV","root_scroller":"GV","scroller":"HV","indicator":"IV","scrollButtons":"JV","selected":"KV","root_tab_scrollable":"LV","root_scroller_mob":"MV","scroller_mob":"NV","indicator_mob":"OV","selected_mob":"PV","root_tab_mob":"QV","root_tab_mob_scrollable":"RV","sticky_header_title_mob":"SV"};
    if(module.hot) {
      // 1713969936733
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  